import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { NotificationService } from '@gfe/core/services/notification/notification.service';

import { SESSION_EXPIRED_KEY } from '@core/constants/auth.constants';

/**
 * Surfaces a one-time notice when the user returns from a Keycloak re-auth that
 * was triggered by an expired session. The notice cannot be shown at the moment
 * the session expires because the full-page redirect to Keycloak wipes any
 * in-page notification, so the interceptor only sets a flag and this service
 * reads it once the app shell is mounted again.
 */
@Injectable({ providedIn: 'root' })
export class SessionExpiryNoticeService {
  private readonly notificationService = inject(NotificationService);
  private readonly translate = inject(TranslateService);

  /**
   * If a previous request flagged the session as expired, show the notice and
   * clear the flag so it only fires once. Safe to call on every shell init.
   */
  showIfExpired(): void {
    if (sessionStorage.getItem(SESSION_EXPIRED_KEY) !== 'true') {
      return;
    }
    sessionStorage.removeItem(SESSION_EXPIRED_KEY);
    this.notificationService.info(
      this.translate.instant('login.session_expired.title'),
      this.translate.instant('login.session_expired.message'),
      10000
    );
  }
}
